module.exports = __webpack_public_path__ + "assets/chengzi.98f8f49d.svg";